module.exports = __webpack_public_path__ + "media/images/flags/16/Papua-New-Guinea-0c7ab34d50de59e97d649235dd591ab4.png";